import { gql } from '@apollo/client';

export interface BsbDetails {
  bsb: string;
  financialInstitutionCode: string;
  suburb: string;
}

export interface BsbValidateQueryRDTO {
  validateBSB: BsbDetails;
}

export interface BsbValidateQueryDTO {
  verifyBsbInput: { bsbNumber: string };
}

export const BSB_VALIDATE_QUERY = gql`
  query ValidateBSB($verifyBsbInput: ValidateBSBInput) {
    validateBSB(validateBSBInput: $verifyBsbInput) {
      bsb
      financialInstitutionCode
      suburb
    }
  }
`;
